import { render, staticRenderFns } from "./productClass_info.vue?vue&type=template&id=478787ea&scoped=true&"
import script from "./productClass_info.vue?vue&type=script&lang=js&"
export * from "./productClass_info.vue?vue&type=script&lang=js&"
import style0 from "./productClass_info.vue?vue&type=style&index=0&id=478787ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478787ea",
  null
  
)

/* custom blocks */
import block0 from "./productClass_info.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports